module.exports = __webpack_public_path__ + "static/img/hail-claim.5a84831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/hail-claim.jpg
// module id = XCs3
// module chunks = 0